import React from "react";
import {SelectChangeEvent} from "@mui/material";

export class UtilityForm{
    /**
     * Aggiorna un campo in un oggetto stato
     * @param name - Nome del campo da aggiornare
     * @param value - Nuovo valore del campo
     * @param setState - Funzione setter dello stato
     */
    static updateField<T>(
        name: keyof T,
        value: any,
        setState: React.Dispatch<React.SetStateAction<T>>
    ): void {
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    /**
     * Change data field
     */
    static handleDateChange<T>(
        name: keyof T,
        value: any,
        setState: React.Dispatch<React.SetStateAction<T>>
    ): void {
        UtilityForm.updateField(name, value, setState);
    }

    /**
     * Gestisce il change di un input form generico
     * @param event - Evento di change
     * @param setState - Funzione setter dello stato
     */
    static handleInputChange<T>(
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> | SelectChangeEvent,
        setState: React.Dispatch<React.SetStateAction<T>>
    ): void {
        const { name, value } = event.target;
        const type = 'type' in event.target ? event.target.type : undefined;

        // Gestione checkbox
        if (type === 'checkbox' && 'checked' in event.target) {
            const checked = (event.target as HTMLInputElement).checked;
            UtilityForm.updateField(name as keyof T, checked, setState);
        } else {
            UtilityForm.updateField(name as keyof T, value, setState);
        }
    }

    /**
     * Gestisce il change di uno Slider
     * @param event - Evento di change dello slider
     * @param newValue - Nuovo valore dello slider
     * @param activeThumb - Indice del thumb attivo (per slider multipli)
     * @param setState - Funzione setter dello stato
     */
    static handleSliderChange<T>(
        event: any,
        newValue: number | number[],
        activeThumb: number,
        setState: React.Dispatch<React.SetStateAction<T>>
    ): void {
        const { name } = event.target;
        //const target = event.target as HTMLElement;
        //const name = target.getAttribute('name');

        if (name) {
            UtilityForm.updateField(name as keyof T, newValue, setState);
        }
    }

}